import React, { useEffect, useRef } from 'react';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { BlockSelectModal } from './BlockSelectModal';
import { ClickableIcon } from '@client/new/components/basic';
import { F0 } from '@client/new/helpers/types';
import { useOptionalCreator } from '../LandingPageBuilder';
import { ISection } from '../types';
import { isEmpty } from 'lodash';
import { getSectionsForBuilder, BuilderType } from '../section-config';

type Props = {
  onAdd: (o: ISection['type']) => void;
  hasOfferId?: boolean;
  builderType?: BuilderType;
};

export function AddSection({ onAdd, hasOfferId, builderType }: Props) {
  const [show, setShow] = React.useState(false);
  const ref = useRef<{ focus: F0 }>(null);

  const creator = useOptionalCreator();

  const isOTPOnly =
    creator &&
    !isEmpty(creator.publishedPrograms) &&
    creator.publishedPrograms.every((p) => p.accessType === 'exclusive');

  // Use the centralized config system
  // Default to channel-landing-page for backward compatibility
  const effectiveBuilderType = builderType || 'channel-landing-page';
  const tabs = getSectionsForBuilder(effectiveBuilderType, {
    isOTPOnly,
    hasOfferId,
  });

  useEffect(() => {
    if (show && ref.current) ref.current.focus();
  }, [show]);

  return (
    <>
      <BlockSelectModal
        onClose={() => setShow(false)}
        onSelect={onAdd}
        isOpen={show}
        tabs={tabs}
      />
      <div className="text-xl w-10 h-10 bg-[#E1E5F0] rounded-lg flex items-center justify-center">
        <ClickableIcon
          icon={faPlus}
          onClick={() => setShow(true)}
          title="Add new block"
        />
      </div>
    </>
  );
}
